/* eslint-disable */
// GENERATED FILE - DO NOT EDIT
import React, { SVGProps } from "react";

const SvgVolunteering = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20.878} viewBox="0 0 20.878 31.671" {...props}>
    <path
      data-name="Path 191"
      d="M18.548 15.444v15.763H2.81V15.444a1.229 1.229 0 01.891-1.181l6.981-2 6.981 2a1.228 1.228 0 01.885 1.181z"
      fill="#12b05e"
    />
    <path
      data-name="Path 192"
      d="M17.662 14.263l-2.075-.594a1.227 1.227 0 01.814 1.156v4.111a3.963 3.963 0 00-5.1.427l-.69.69-.69-.69a3.962 3.962 0 00-6.706 2.127h-.408v8.289a3.21 3.21 0 004.071-2.251l3.114 3.114a.876.876 0 001.238 0l3.223-3.223a3.221 3.221 0 001.946 2.281v1.506h2.149V15.444a1.228 1.228 0 00-.886-1.181z"
      fill="#12b05e"
    />
    <path data-name="Path 193" d="M18.555 21.738v9.469h-13.4z" fill="#ffcd27" />
    <path
      data-name="Path 194"
      d="M18.552 21.738v9.469h-2.151v-1.506a3.22 3.22 0 01-1.942-2.284l-3.223 3.223a.875.875 0 01-1.238 0l-1.673-1.673z"
      fill="#ebb400"
    />
    <g data-name="Group 52" fill="#12b05e">
      <g data-name="Group 50">
        <path
          data-name="Path 195"
          d="M3.775 28.694a1.973 1.973 0 01-1.973-1.973V22.73h3.945v3.991a1.973 1.973 0 01-1.972 1.973z"
        />
        <path
          data-name="Path 196"
          d="M5.749 22.728v3.991a1.973 1.973 0 01-2.826 1.779 1.972 1.972 0 001.119-1.779v-3.991z"
        />
      </g>
      <g data-name="Group 51">
        <path
          data-name="Path 197"
          d="M17.588 28.694a1.973 1.973 0 01-1.973-1.973V22.73h3.945v3.991a1.973 1.973 0 01-1.972 1.973z"
        />
        <path
          data-name="Path 198"
          d="M19.562 22.728v3.991a1.973 1.973 0 01-2.826 1.779 1.972 1.972 0 001.119-1.779v-3.991z"
        />
      </g>
    </g>
    <g data-name="Group 55">
      <g data-name="Group 53" transform="translate(3.785 8.123)" fill="#ffbd86">
        <circle
          data-name="Ellipse 23"
          cx={1.631}
          cy={1.631}
          r={1.631}
          transform="translate(10.394)"
        />
        <circle data-name="Ellipse 24" cx={1.631} cy={1.631} r={1.631} />
      </g>
      <path
        data-name="Path 199"
        d="M15.284 4.797v4.735a4.67 4.67 0 01-9.341 0V4.797z"
        fill="#fed2a4"
      />
      <path
        data-name="Path 200"
        d="M5.943 4.797h9.341v3.326H5.943z"
        fill="#ffbd86"
      />
      <path
        data-name="Path 201"
        d="M4.956 6.121a5.657 5.657 0 1111.314.071v.044a.663.663 0 01-.663.663H5.62a.663.663 0 01-.663-.663z"
        fill="#3e5564"
      />
      <path
        data-name="Path 202"
        d="M16.271 6.192v.044a.664.664 0 01-.663.663h-1.835a.664.664 0 00.663-.663v-.044A5.721 5.721 0 009.694.539a5.607 5.607 0 01.963-.075 5.7 5.7 0 015.614 5.728z"
        fill="#344b5a"
      />
      <g data-name="Group 54" fill="#384848">
        <path
          data-name="Path 203"
          d="M11.768 6.901l.557-2.127a.351.351 0 01.679 0l.557 2.127z"
        />
        <path
          data-name="Path 204"
          d="M7.584 6.9l.746-2.851a.47.47 0 01.91 0L9.986 6.9z"
        />
      </g>
    </g>
    <g data-name="Group 56">
      <path
        data-name="Path 205"
        d="M16.908 17.484a3.963 3.963 0 00-5.6 0l-.69.69-.69-.69a3.963 3.963 0 10-5.6 5.6l5.675 5.675a.876.876 0 001.238 0l5.675-5.675a3.963 3.963 0 00-.008-5.6z"
        fill="#fb6672"
      />
      <path
        data-name="Path 206"
        d="M16.908 23.088l-5.675 5.675a.876.876 0 01-1.238 0l-.589-.589 5.468-5.468a3.965 3.965 0 00-1.077-6.37 3.963 3.963 0 013.111 6.753z"
        fill="#fb4a59"
      />
    </g>
    <g data-name="Group 60">
      <g data-name="Group 57" transform="translate(15.722 18.474)">
        <circle
          data-name="Ellipse 25"
          cx={2.346}
          cy={2.346}
          r={2.346}
          fill="#ffcec0"
        />
        <path
          data-name="Path 207"
          d="M4.692 2.342A2.346 2.346 0 01.76 4.07c.055 0 .11.006.166.006A2.346 2.346 0 002.512.002a2.346 2.346 0 012.18 2.34z"
          fill="#fdb0a0"
        />
      </g>
      <g data-name="Group 59">
        <circle
          data-name="Ellipse 26"
          cx={2.346}
          cy={2.346}
          r={2.346}
          transform="translate(.464 18.474)"
          fill="#ffcec0"
        />
        <path
          data-name="Path 208"
          d="M5.156 20.821a2.346 2.346 0 01-3.932 1.729c.055 0 .11.005.165.005a2.346 2.346 0 001.586-4.075 2.347 2.347 0 012.181 2.341z"
          fill="#fdb0a0"
        />
        <g data-name="Group 58">
          <path
            data-name="Path 209"
            d="M8.26 8.837h-.007a.464.464 0 00-.008.928h.011a.464.464 0 000-.928z"
          />
          <path
            data-name="Path 210"
            d="M12.983 8.837h-.011a.464.464 0 000 .928h.011a.464.464 0 000-.928z"
          />
          <path
            data-name="Path 211"
            d="M16.735 6.237A6.212 6.212 0 0010.662 0a6.072 6.072 0 00-4.36 1.777 6.347 6.347 0 00-1.809 4.46 1.128 1.128 0 00.986 1.118v.307h-.062a2.1 2.1 0 10.577 4.11 5.151 5.151 0 00.757 1.138l-3.177.91a1.7 1.7 0 00-1.226 1.627v2.603a2.809 2.809 0 00-1.008 5.164v.981a.464.464 0 00.928 0v-.617a2.8 2.8 0 001.694-.194l1.323 1.386v1.95a1.509 1.509 0 11-3.017 0v-.3a.464.464 0 00-.928 0v.3a2.434 2.434 0 001.008 1.972v2.516a.464.464 0 10.928 0V29.1a2.437 2.437 0 002.936-2.38v-1.085l2.495 2.495-3.817 2.7a.464.464 0 10.536.758L9.372 28.8l.295.295a1.341 1.341 0 001.894 0l3.59-3.59v1.22a2.437 2.437 0 002.938 2.385v2.1a.464.464 0 00.928 0v-2.519a2.435 2.435 0 001.008-1.972v-3.883a2.807 2.807 0 00-1.008-4.66v-2.732a1.7 1.7 0 00-1.227-1.627l-.553-.158a.464.464 0 10-.255.892l.553.158a.768.768 0 01.554.735v2.567h-.02c-.054 0-.108 0-.162.005a4.442 4.442 0 00-.671-.86 4.427 4.427 0 00-6.26 0l-.362.362-.362-.362a4.429 4.429 0 00-1.92-1.128.464.464 0 00-.253.893 3.5 3.5 0 011.517.891l.69.69a.464.464 0 00.656 0l.69-.69a3.5 3.5 0 014.948 0 3.526 3.526 0 01.367.434 2.807 2.807 0 00-.626 4.774l-5.415 5.415a.412.412 0 01-.582 0l-5.578-5.578a2.806 2.806 0 00-.554-4.482 3.508 3.508 0 011.926-1.441.464.464 0 10-.266-.889A4.431 4.431 0 003.3 18.054h-.024v-2.61a.768.768 0 01.554-.735l3.716-1.064a5.123 5.123 0 006.176-.029h.007s1.2.338 1.245.338a.464.464 0 00.127-.91l-.595-.17a5.15 5.15 0 00.73-1.108 2.1 2.1 0 10.576-4.11h-.062v-.302a1.128 1.128 0 00.986-1.118zm-10.328 3.3V7.364h8.413v2.168a4.207 4.207 0 01-8.413 0zm1.778-3.1l.594-2.269h.01l.594 2.269zm4.184 0l.3-1.129.3 1.129zm3.441 2.151a1.167 1.167 0 11-.248 2.312 5.118 5.118 0 00.185-1.364V8.59h.062zm0-2.351a.2.2 0 01-.2.2h-1.688l-.466-1.781a.815.815 0 00-1.577 0l-.466 1.781h-1.067l-.656-2.5a.934.934 0 00-1.808 0l-.656 2.5H5.62a.2.2 0 01-.2-.2 5.427 5.427 0 011.535-3.8A5.157 5.157 0 0110.613.928h.04a5.282 5.282 0 015.154 5.309zM5.42 10.922a1.167 1.167 0 010-2.335h.062v.942a5.119 5.119 0 00.18 1.371 1.173 1.173 0 01-.245.022zm-4.489 9.9A1.882 1.882 0 112.81 22.7a1.884 1.884 0 01-1.882-1.879zm17.14-1.882a1.882 1.882 0 11-1.882 1.882 1.884 1.884 0 011.882-1.882zm-1.995 5.639l1.1-1.1a2.8 2.8 0 001.928-.047v3.284a1.509 1.509 0 01-3.017 0z"
          />
        </g>
      </g>
    </g>
  </svg>
);

SvgVolunteering.defaultProps = {};
export default SvgVolunteering;
/* eslint-enable */
